<template>
    <section>
        <div class="modal-card" style="width: 1280px; max-width: 100%;">
            <header class="modal-card-head">
                <p class="modal-card-title">Composición Patentes Por Estado</p>
                <button type="button" class="delete" @click="$emit('close')" />
            </header>
            <section class="modal-card-body">

                <div class="columns is-centered">
                    <div class="column">

                        <b-table :data="composition" :paginated="true" per-page="10" striped hoverable
                            :pagination-simple="false" pagination-active-color="hsl(0, 0%, 0%)"
                            pagination-position="bottom" default-sort-direction="asc" sort-icon="arrow-up"
                            aria-next-label="Siguiente" aria-previous-label="Anterior" aria-page-label="Página"
                            aria-current-label="Página actual">

                            <b-table-column field="title" label="Título" sortable searchable>
                                <template #searchable="props">
                                    <b-input v-model="props.filters[props.column.field]" placeholder="Buscar Título..."
                                        icon="search" />
                                </template>
                                <template v-slot="props">
                                    {{ props.row.title }}
                                </template>
                            </b-table-column>

                            <b-table-column field="protection_code" label="Código de Protección" sortable searchable>
                                <template #searchable="props">
                                    <b-input v-model="props.filters[props.column.field]" placeholder="Buscar Código..."
                                        icon="search" />
                                </template>
                                <template v-slot="props">
                                    {{ props.row.protection_code }}
                                </template>
                            </b-table-column>

                            <b-table-column field="state_name" label="Estado Patente" sortable searchable>
                                <template #searchable="props">
                                    <b-input v-model="props.filters[props.column.field]" placeholder="Buscar Estado..."
                                        icon="search" />
                                </template>
                                <template v-slot="props">
                                    {{ props.row.state_name }}
                                </template>
                            </b-table-column>

                            <b-table-column field="date_state" label="Fecha del Estado de la Patente" sortable searchable
                                :custom-search="searchCustomDateState">
                                <template #searchable="props">
                                    <b-input v-model="props.filters[props.column.field]"
                                        placeholder="Buscar Fecha de Estado..." icon="search" />
                                </template>
                                <template v-slot="props">
                                    {{ props.row.date_state._isValid ? new Date(props.row.date_state).toLocaleDateString("es-CL") : '' }}
                                </template>
                            </b-table-column>

                            <b-table-column field="id" width="100" label="Acciones" v-slot="props" size="is-small">
                                <b-button pack="fas" icon-right="eye" type="is-info" tag="a"
                                    :href="/patents/ + props.row.id" target="_blank" />
                            </b-table-column>

                        </b-table>

                    </div>
                </div>

            </section>

            <footer class="modal-card-foot">
                <b-button label="Cerrar" @click="$emit('close')" />
            </footer>

        </div>
        <b-loading :is-full-page="true" v-model="isLoading" :can-cancel="false" />
    </section>
</template>

<script>
import axios from 'axios'
import moment from "moment"
import {searchDate} from "../../packs/utilities"
export default {

    name: 'modal_composition_by_type_patent',

    props: [
        'minYear', 'maxYear', 'unitId',
    ],

    data() {
        return{
            isLoading: false,
            composition: [],
        }
    },

    async created() {
        await this.getCompositionFing43()
    },

    methods: {

        async getCompositionFing43() {
            this.isLoading = true
            await axios
                .get('/dashboards/get-indicator-composition-for-unit.json', {
                    params: {
                        unit_id: this.unitId,
                        minYear: this.minYear,
                        maxYear: this.maxYear,
                        indicator_code: 'fing43',
                    }
                })
                .then(response => {
                    this.composition = response.data

                    this.composition.forEach(patent => {
                        var newPatent = patent
                        newPatent.date_state = moment(newPatent.date_state, ["YYYY-MM-DD","DD-MM-YYYY"])
                        return newPatent
                    })
                })
                .catch(error => {
                    this.$buefy.dialog.alert({
                        title: 'Error',
                        message: 'Hubo un error al obtener los datos. Intente más tarde.',
                        type: 'is-danger',
                        hasIcon: true,
                        icon: 'times-circle',
                        iconPack: 'fa',
                        ariaRole: 'alertdialog',
                        ariaModal: true
                    })
                }).finally(() => {
                    this.isLoading = false
                })
        },


        searchCustomDateState(row, input) {
            return searchDate (row.date_state, input)
        },

    },

}
</script>